import { render, staticRenderFns } from "./SIPDataModalView.vue?vue&type=template&id=16703bec&scoped=true"
import script from "./SIPDataModalView.vue?vue&type=script&lang=js"
export * from "./SIPDataModalView.vue?vue&type=script&lang=js"
import style0 from "./SIPDataModalView.vue?vue&type=style&index=0&id=16703bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16703bec",
  null
  
)

export default component.exports